import { Component, OnInit } from "@angular/core"
import { ReportItemType } from "@app/definitions/types"
import { PersonCommonComponent } from "@app/person-common/person-common.component"

@Component({
	selector: "app-payor",
	templateUrl: "../person-common/person-common.component.html",
})
export class PayorComponent extends PersonCommonComponent implements OnInit {
	//inherits some fields and methods from PersonCommons!
	personType: ReportItemType = "payor" //used by PersonCommons to generalize
}
